// Códigos ISO 4217 numéricos, que es lo que espera el API de pagos.
const currencies = [
  { code: '484', label: 'MXN' },
  { code: '840', label: 'USD' },
];

const DEFAULT_CURRENCY = '484';

const currencyHelper = {
  getCurrencies: () => currencies,
  getLabel: (code) => {
    const currency = currencies.find((item) => item.code === code);

    return currency ? currency.label : '';
  },
};

export { DEFAULT_CURRENCY };
export default currencyHelper;
